function isAmountGreaterThanZero(value: string): boolean {
  if (!value) return false

  const amountString = value.replace(/[^0-9,.]/g, '')
  return amountString && !!amountString.match(/[1-9]/)
}

function isValidAmount(value: string): boolean {
  if (!value) return false

  const amountString = value.replace(/[^0-9,.]/g, '')
  return amountString && !!amountString.match(/[0-9]/)
}

export { isAmountGreaterThanZero, isValidAmount }